import React, { Component } from 'react'
import { connect } from 'react-redux'
import {getFormattedTime, docStatusToString, docHasPlagExtra} from '../../../util/displayUtils.js';
import { Link } from 'react-router-dom'

class AdminDocumentsTable extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        var docs = this.props.documents.map(function(doc, i){
            var tax = 0;
            var province = "";
            var payMethod = "";
            var doc_actual_cost = doc.doc_cost;
            if(doc.receipt) {
              tax = doc.receipt.receipt_tax;
              province = doc.receipt.receipt_location;
              payMethod = doc.receipt.receipt_payment_type;
              doc_actual_cost = doc.receipt.receipt_total_amount;
            }
            var docPages = Math.ceil(doc.word_count/325);
            var editorEmail = "NA";
            if(doc.editor_user_id) {
                editorEmail = doc.email; // this is join of user table to result set based on editor_user_id
            }
            var boldForPlagClass = "";
            if(doc.extras && docHasPlagExtra(doc.extras)) {
              boldForPlagClass = "adminDocPlagBold";
            }
            return(
              <tr key={i} className={boldForPlagClass}>
                <td><Link to={"/admindashboard/document/" + doc.doc_id}>{doc.doc_name}</Link></td>
                <td><Link to={"/admindashboard/user/" + doc.student_user_id}> {doc.user_email || "NA" } </Link></td>
                <td><Link to={"/admindashboard/user/" + doc.editor_user_id}>{doc.email || "NA" }</Link></td>
                <td>{docStatusToString(doc.doc_status)}</td>
                <td>{doc.word_count}</td>
                <td>{docPages}</td>
                <td>{doc.time_limit}</td>
                <td>{doc_actual_cost}</td>
                <td>{doc.editor_level}</td>
                <td>{doc.english}</td>
                <td>{getFormattedTime(doc.due_date)}</td>
                <td>{getFormattedTime(doc.upload_date)}</td>
                <td>{tax}</td>
                <td>{province}</td>
                <td>{payMethod}</td>
                <td>{doc.editorPay}</td>
              </tr>
            )
          });
        return (
            <table className="dashboard-paperlist">
            <tbody>
              <tr>
                <th>Name</th>
                <th>Student Email</th>
                <th>Editor Email</th>
                <th>Status</th>
                <th>Word Count</th>
                <th># Pages</th>
                <th>Time Limit</th>
                <th>Price</th>
                <th>Level</th>
                <th>English</th>
                <th>Due Date</th>
                <th>Upload Date</th>
                <th>Tax</th>
                <th>Province</th>
                <th>Payment Method</th>
                <th>Pay</th>
              </tr>
              {docs}
            </tbody>
          </table>
        )
    }
}
export default connect( ({AdminDocumentsTable}) => ({AdminDocumentsTable}) ) (AdminDocumentsTable)



// WEBPACK FOOTER //
// ./src/components/dashboards/AdminDashboard/AdminDocumentsTable.js